// extracted by mini-css-extract-plugin
module.exports = {"defaultAppearance":"FullScreen_defaultAppearance__ap2vo"};